var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlunosNaoSelecionados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#8E58BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27V25C22 23.9391 21.5786 22.9217 20.8284 22.1716C20.0783 21.4214 19.0609 21 18 21H12C10.9391 21 9.92172 21.4214 9.17157 22.1716C8.42143 22.9217 8 23.9391 8 25V27M28 27V25C27.9993 24.1137 27.7044 23.2528 27.1614 22.5523C26.6184 21.8519 25.8581 21.3516 25 21.13M22 9.13C22.8604 9.3503 23.623 9.8507 24.1676 10.5523C24.7122 11.2539 25.0078 12.1168 25.0078 13.005C25.0078 13.8932 24.7122 14.7561 24.1676 15.4577C23.623 16.1593 22.8604 16.6597 22 16.88M19 13C19 15.2091 17.2091 17 15 17C12.7909 17 11 15.2091 11 13C11 10.7909 12.7909 9 15 9C17.2091 9 19 10.7909 19 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlunosNaoSelecionados);
export default __webpack_public_path__ + "static/media/iconAlunosNaoSelecionados.e5566ff5973eab39faed6af73b693569.svg";
export { ForwardRef as ReactComponent };